export enum ProductCategoryType {
    Fuel = 'Fuel',
    Consumable = 'Consumable',
    Service = 'Service',
    Workshop = 'Workshop'
}
